<template>
  <div class='revision-history-panel'>
    <div class=''>
      <div class='revision-history-panel__revisions'>
        <oval-label class='revision-history-panel__revisions-circle'>
          Revisions
        </oval-label>
        <oval-label
          @click.native="clearRevisionHistory"
          class="revision-history-panel__clear">
          CLEAR
        </oval-label>
      </div>
      <scroll-panel :height="heightOfRevisions" class='revision-history-panel__scroll-header'>
        <revision-history
          :key="rh.id" v-for="rh in revisionHistories"
          v-bind="rh"
          :currentAudience="currentAudience"
          :isCurrentRevision="rh.id === selectedRevision"
          :goto="() => onClickRevisionHistory(rh)"
          :class="{
            'revision-history-panel__revision': true,
            'revision-history-panel__current-move': rh.id === selectedRevision
          }"
        ></revision-history>
      </scroll-panel>
    </div>
    <div class="revision-history-panel__dividor">
      <oval-label class='revision-history-panel__branch-header'>
        Versions
      </oval-label>
      <positive-circle :size="21" class="revision-history-panel__add-branch"
        @click.native="createNewBranch"
      ></positive-circle>
      <span>
          {{currentBranchLabel}}
      </span>
      <scroll-panel :height="heightOfBranches" class="revision-history-panel__scroll-header">
        <template v-for="b in branches">
          <branch
            :key="b.id"
            v-bind="b"
            v-if="b.id !== selectedBranch"
            :goto="() => onClickBranch(b)"
            :currentAudience="currentAudience"
            :isCurrentBranch="b.id === selectedBranch"
            :deleteBranch="() => deleteBranch(b)"
            :class="{
              'revision-history-panel__branch': true,
              'revision-history-panel__current-branch': b.id === selectedBranch
            }"
          ></branch>
        </template>
      </scroll-panel>
    </div>
  </div>
</template>

<script>
import RevisionHistory from './RevisionHistory'
import Branch from './Branch'
import {OvalLabel} from '@/components/common/ovalLabel'
import {PositiveCircle} from '@/components/common/positiveityIndicator'
import ScrollPanel from '@/components/common/scrollPanel'

export default {
  components: {
    RevisionHistory,
    Branch,
    OvalLabel,
    PositiveCircle,
    ScrollPanel
  },
  props: {
    branches: {
      type: Array,
      default: () => []
    },
    revisionHistories: {
      type: Array,
      default: () => []
    },
    selectedBranch: {
      type: String
    },
    selectedRevision: {
      type: String
    },
    onClickRevisionHistory: {
      type: Function,
      default: () => {}
    },
    onClickBranch: {
      type: Function,
      default: () => {}
    },
    currentAudience: {
      type: Number,
      default: 0
    },
    createNewBranch: {
      type: Function,
      required: true
    },
    heightOfBranches: {
      type: Number,
      default: 200
    },
    heightOfRevisions: {
      type: Number,
      default: 300
    },
    deleteBranch: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    currentBranch () {
      return this.branches.find(b => b.id === this.selectedBranch)
    },
    currentBranchLabel () {
      return 'Current Version: ' + this.currentBranch.label
    }
  }
}
</script>

<style lang='scss'>
.revision-history-panel {
  margin-top: 15px;

  &__current-move {
    background-color: color(blue-grey, very-dark);
  }

  &__current-branch {
    background-color: color(blue-grey, very-dark);
  }

  &__branch-header{
    background-color: gray;
    color: white;
    border-color: gray !important;
    padding-left: 15px;
    padding-bottom: 15px;
    margin-left: 25px;
    margin-right: 10px;
  }

  &__branch {
    border-style: solid;
    border-width: 1px 1px 1px 1px;
    border-color: gray;
  }

  &__seperator {
    border-style: solid;
    border-width: 8px 0px 0px 0px;
    border-color: gray;
  }

  &__scroll-header {
    border-color: gray !important;
    border-bottom: 1px solid;
    border-top: 1px solid;
    width: 98%
  }
  &__revisions {
    padding-top: 10px;
  }
  &__revisions-circle {
    background-color: gray;
    color: white;
    border-color: gray !important;
    border-bottom: 1px solid;
    padding-left: 15px;
    padding-bottom: 15px;
    margin-left: 25px;
  }

  &__dividor {
    border-color: gray !important;
    border-top: 4px solid;
    margin-top: 10px;
  }

  &__revision {
    border-style: solid;
    border-width: 1px 1px 1px 1px;
    border-color: gray;
    padding-left: 15px;
  }

  &__clear {
    background-color: red;
    border-color: red !important;
    margin-left: 15px;
  }

  &__add-branch {
    margin-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// RevisionHistoryPanel.vue?4b6d8363